import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { APIs } from '../../utilities/APIs';
import { useAuth } from '../../users/AuthContext';
import ApplicantNotices from '../../components/ApplicantNotices';
import { UnikLog } from '../../assets';
import './ApplicantAuth.css';

const ApplicantLogin = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [email, setEmail] = useState('');const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [showOtpSection, setShowOtpSection] = useState(false);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setError('');
    };

    const handleOtpChange = (index, value) => {
        if (value.length > 1) return; // Prevent multiple characters
        
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Auto-focus next input
        if (value && index < 5) {
            const nextInput = document.getElementById(`applicant-otp-${index + 1}`);
            if (nextInput) nextInput.focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            const prevInput = document.getElementById(`applicant-otp-${index - 1}`);
            if (prevInput) prevInput.focus();
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, 6);
        const newOtp = pastedData.split('').concat(['', '', '', '', '', '']).slice(0, 6);
        setOtp(newOtp);
        
        // Focus the last filled input or the next empty one
        const lastIndex = Math.min(pastedData.length, 5);
        setTimeout(() => {
            const targetInput = document.getElementById(`applicant-otp-${lastIndex}`);
            if (targetInput) targetInput.focus();
        }, 0);
    };



    const handleRequestOtp = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');        try {
            const response = await fetch(APIs.applicant.requestLoginOtp, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (response.ok && data.status === 'success') {
                setSuccess('OTP sent successfully to your email');
                setShowOtpSection(true);
            } else {
                setError(data.message || 'Failed to send OTP');
            }
        } catch (error) {
            setError('Network error. Please try again.');
            console.error('Request OTP error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        const otpValue = otp.join('');
        if (otpValue.length !== 6) {
            setError('Please enter the complete 6-digit OTP');
            return;
        }
        
        setLoading(true);
        setError('');

        try {
            console.log('Sending OTP verification request for:', email);            const response = await fetch(APIs.applicant.verifyLoginOtp, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, otp: otpValue })
            });

            const data = await response.json();
            console.log('OTP verification response:', data);            
            
            if (response.ok && data.status === 'success') {
                console.log('OTP verification successful, processing login...');
                  // Handle the actual response structure from backend
                if (data.data && data.data.token) {
                    const applicantData = {
                        id: data.data.applicantId,
                        username: data.data.username,
                        email: email, // Use the email from form
                        role: data.data.role,
                        applicationFormType: data.data.applicationFormType,
                        submittedApplicationId: data.data.submittedApplicationId,
                        userType: 'APPLICANT',
                        // Include both APPLICANT and ROLE_APPLICANT for compatibility
                        roles: ['APPLICANT', 'ROLE_APPLICANT']
                    };
                    
                    console.log('Applicant data to store:', applicantData);
                    console.log('Token received:', data.data.token);
                      // Use the AuthContext login method with proper token handling
                    login(data.data.token, data.data.token, applicantData); // Use same token for refresh for now
                    
                    console.log('AuthContext login called, authentication state should be updated...');
                    
                    // Wait a moment for state to update and check authentication
                    setTimeout(() => {
                        // Force a check of the authentication state
                        const storageCheck = {
                            jwtToken: localStorage.getItem('jwtToken'),
                            userData: localStorage.getItem('userData'),
                            refreshToken: localStorage.getItem('refreshToken')
                        };
                        console.log('Post-login storage check:', storageCheck);
                        console.log('Attempting navigation to /applicant/dashboard');
                        navigate('/applicant/dashboard');
                    }, 500); // Reduced timeout for better UX
                } else {
                    console.error('Missing token in response:', data);
                    setError('Login failed - no authentication token received');
                    return;
                }                
                setSuccess('Login successful! Redirecting...');
            } else {
                console.error('OTP verification failed:', data);
                setError(data.message || 'Invalid OTP. Please try again.');
            }
        } catch (error) {
            console.error('Verify OTP error:', error);
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };    const handleBackToEmail = () => {
        setShowOtpSection(false);
        setOtp(['', '', '', '', '', '']);
        setError('');
        setSuccess('');
    };

    const resendOtp = () => {
        setOtp(['', '', '', '', '', '']);
        setError('');
        handleRequestOtp({ preventDefault: () => {} });
    };    return (
        <div className="applicant-page">
            <div className="applicant-container">
                <div className="applicant-notices">
                    <ApplicantNotices page="LOGIN" maxNotices={2} />
                </div>

                <div className="applicant-header">
                    <img src={UnikLog} className='applicant-logo' alt="UNIK Logo" />
                    <h1 className="applicant-title">
                        {showOtpSection ? 'Verify your Email' : 'Applicant Login'}
                    </h1>
                    {showOtpSection && (
                        <p className="applicant-subtitle">
                            Enter the 6-digit code sent to {email}
                        </p>
                    )}
                </div>

                <form onSubmit={showOtpSection ? handleVerifyOtp : handleRequestOtp} className="applicant-form">
                    {!showOtpSection ? (
                        <>
                            <div className="applicant-input-group">
                                <label htmlFor="email" className="applicant-input-label">Email Address</label>
                                <div className="applicant-input-container">
                                    <input
                                        type="email"
                                        className="applicant-form-input"
                                        id="email"
                                        value={email}
                                        onChange={handleEmailChange}
                                        placeholder="Enter your email address"
                                        required
                                        disabled={loading}
                                    />
                                </div>
                            </div>
                            
                            <button
                                type="submit"
                                className="applicant-btn-primary"
                                disabled={loading || !email}
                            >
                                {loading ? (
                                    <>
                                        <div className="applicant-loading-spinner"></div>
                                        Sending...
                                    </>
                                ) : (
                                    'Send Verification Code'
                                )}
                            </button>
                        </>
                    ) : (
                        <>
                            <div className="applicant-otp-section">
                                <div className="applicant-otp-inputs">
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            id={`applicant-otp-${index}`}
                                            type="text"
                                            maxLength="1"
                                            className={`applicant-otp-input ${digit ? 'filled' : ''}`}
                                            value={digit}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                            onPaste={handleOtpPaste}
                                            disabled={loading}
                                        />
                                    ))}
                                </div>
                                
                                <button
                                    type="submit"
                                    className="applicant-btn-primary"
                                    disabled={loading || otp.join('').length !== 6}
                                >
                                    {loading ? (
                                        <>
                                            <div className="applicant-loading-spinner"></div>
                                            Verifying...
                                        </>
                                    ) : (
                                        'Verify & Login'
                                    )}
                                </button>
                                
                                <div className="applicant-resend-section">
                                    <span>Didn't receive the code? </span>
                                    <button
                                        type="button"
                                        className="applicant-btn-link"
                                        onClick={resendOtp}
                                        disabled={loading}
                                    >
                                        Resend it
                                    </button>
                                </div>
                                
                                <button
                                    type="button"
                                    className="applicant-btn-secondary"
                                    onClick={handleBackToEmail}
                                    disabled={loading}
                                >
                                    Back to Email
                                </button>
                            </div>
                        </>
                    )}
                </form>
                
                {error && (
                    <div className="applicant-message applicant-message-error" role="alert">
                        {error}
                    </div>
                )}
                
                {success && (
                    <div className="applicant-message applicant-message-success" role="alert">
                        {success}
                    </div>
                )}

                <div className="applicant-nav-link">
                    <p>Don't have an account? <a href="/applicant/register">Register here</a></p>
                    <p>Are you a staff member? <a href="/login">Staff Login</a></p>
                </div>
            </div>
        </div>
    );
};

export default ApplicantLogin;
